import OSS from 'ali-oss'
import api from '@/api'

export const OSSClient = async() => {
  const tokenRes = await api.GetOssKey()
  const tokenParams = {
    accessKeyId: tokenRes.data.AccessKeyId,
    accessKeySecret: tokenRes.data.AccessKeySecret,
    bucket: tokenRes.data.bucket,
    stsToken: tokenRes.data.securityToken,
    endpoint: tokenRes.data.endpoint,
    dir: tokenRes.data.dir,
  }
  const client = new OSS(tokenParams)
  return Promise.resolve(client)
}
